// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"695":"b9de9612","875":"e7d9b680"}[chunkId] + ".chunk.js";
};